import { forwardRef } from "react"
import { useController } from "react-hook-form"
import { TextField } from "@mui/material"
import { isPossiblePhoneNumber } from "react-phone-number-input"
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form"

const MuiPhoneInput = forwardRef((props, ref) => {
  return <TextField {...props} inputRef={ref} />
})

export default function PhoneInput({
  control,
  name = "phone",
  requiredErrorMessage = "Please enter recipient's phone number.",
  validationErrorMessage = "Please enter a valid phone number.",
  ...textFieldProps
}) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
  })

  const rules = {
    required: {
      message: requiredErrorMessage,
      value: true,
    },
    validate: {
      isValid: (value) => {
        if (value) {
          if (isPossiblePhoneNumber(value)) {
            return true
          }
          return validationErrorMessage
        } else {
          return requiredErrorMessage
        }
      },
    },
  }

  return (
    <PhoneInputWithCountry
      {...field}
      name={name}
      control={control}
      defaultCountry="US"
      rules={rules}
      error={invalid}
      helperText={error?.message || ""}
      inputComponent={MuiPhoneInput}
      {...textFieldProps}
    />
  )
}
